export default __webpack_public_path__ + "static/media/bottom_image.3cb70be6.svg";